import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Add = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.3704 11.3754H12.6046V4.61961C12.6046 4.27983 12.3248 4 11.985 4C11.6452 4 11.3654 4.27983 11.3654 4.61961V11.3754H4.61961C4.27983 11.3754 4 11.6552 4 11.995C4 12.3348 4.27983 12.6146 4.61961 12.6146H11.3754V19.3804C11.3754 19.7202 11.6552 20 11.995 20C12.3348 20 12.6146 19.7202 12.6146 19.3804V12.6146H19.3804C19.7202 12.6146 20 12.3348 20 11.995C20 11.6552 19.7202 11.3754 19.3804 11.3754H19.3704Z" />
  </svg>
)

export default withDefaultStyles(Add)
